import React from 'react' 
import styled from 'styled-components'

const NotFound = () => {
    return (
        <Container>
            <Inner>
                <Text>
                    4 <Zero>0</Zero> 4
                </Text>
            </Inner>
            <TextU>The page you are looking for does not exist or is temporarily unavailable</TextU>
            <Btn className="button is-outlined" href="/">Home Page </Btn>
        </Container>
    )
}

const Container = styled.div `
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);

    max-width: 38rem;
    width: 100%;
    text-align: center;
    line-height: 1.4;
`

const Inner = styled.div `
    height: 158px;
    line-height: 153px;
`

const Text = styled.h1 `
    font-family: 'Josefin Sans', sans-serif;
    color: #222;
    font-size: 4rem;
    letter-spacing: 10px;
    margin: 0px;
    font-weight: 700;
    text-shadow: 2px 2px 0px #c9c9c9, -2px -2px 0px #c9c9c9;

    @media (min-width: 480px){
        font-size: 180px;
    }
`

const Zero = styled.span `
    text-shadow: 2px 2px 0px #da6c36, -2px -2px 0px #da6c36, 0px 0px 8px #ff8700;
`

const TextU = styled.p `
    font-family: 'Josefin Sans', sans-serif;
    color: #c9c9c9;
    font-size: 16px;
    font-weight: 400;
    margin-top: 0px;
    margin-bottom: 15px;
`

const Btn = styled.a `
    background-color: transparent;
    color: #da6c36;
    border-color: #da6c36;
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 500;

    &:hover {
        background-color: #da6c362e;
        color: #da6c36;
        border-color: #da6c36;
    }
`

export default NotFound;